import { UserInfo } from "../../reducers/states/user-info";

export function NameOrEmailUtil(userInfo: UserInfo) {
  // Return first and last if it exists, otherwise default to email
  return userInfo.firstName && userInfo.lastName
    ? userInfo.firstName + " " + userInfo.lastName
    : userInfo.email;
}

function IsDevUser(authEmail: string | undefined) {
  return !!authEmail && [
        "jeremy.cavner@consultant.wsdot.wa.gov",
        "listed@spinshot.net",
        "ndeko12@gmail.com",
        "dekofsn@wsdot.wa.gov",
      ].includes(authEmail, 0);
}

// todo: jcavner: create a reusable hook which can access authState and searchparams instead of passing them in
export function IsMockDisabled(authEmail: string | undefined, searchParams: URLSearchParams) {
  if (!IsDevUser(authEmail)) return true;

  const mock = searchParams.get('mock');
  const domain = window.location.origin.split("//")[1]?.split(":")[0]?.toLowerCase();
  const isDisabledForNonProd = ["dev.vcc.systems", "stage.vcc.systems"].includes(domain) && mock !== "t";
  const isDisabledForLocalhost = domain === "localhost" && mock === "f";
  
  return isDisabledForNonProd || isDisabledForLocalhost;
}